// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"594":"about","966":"login"}[chunkId] + "." + {"594":"1e4e5244","966":"604447f1"}[chunkId] + ".js";
};